import type { CosmeticSlot, ShopItemView, ShopResponse } from '@bioforge/protocol';
import type { JarSkin } from './jar-view.js';

/** Надетые скины игрока в виде, который понимает банка. */
export function skinOf(shop: Pick<ShopResponse, 'items' | 'equipped'>): JarSkin {
  const look = (slot: CosmeticSlot) => {
    const id = shop.equipped[slot];
    return id ? shop.items.find((item) => item.id === id)?.look : undefined;
  };
  const hats: Partial<Record<number, 'santa' | 'shades'>> = {};
  [0, 1, 2].forEach((color) => {
    const hat = look(`microbe-${color}` as CosmeticSlot);
    if (hat === 'santa' || hat === 'shades') hats[color] = hat;
  });
  const vessel = look('vessel');
  return {
    hats,
    vessel: vessel === 'aquarium' || vessel === 'snowglobe' ? vessel : null,
    capsule: look('capsule') === 'candy' ? 'candy' : null,
  };
}

/** Скин для предпросмотра: надетое игроком плюс выбранный предмет вместо предмета в его слоте. */
export function previewSkin(
  shop: Pick<ShopResponse, 'items' | 'equipped'>,
  item: ShopItemView,
): JarSkin {
  return skinOf({ items: shop.items, equipped: { ...shop.equipped, [item.slot]: item.id } });
}

/** Цена для игрока: «$0.99». */
export function formatPrice(amount: number): string {
  return `$${(amount / 100).toFixed(2)}`;
}
